import { TEST_COMPANIES } from '@blisspointmedia/bpm-types/dist/TestCompanies';
import { DateRange } from './date-utils';

// Static dates to use on certain pages (for client demo purposes).
const DEFAULT_WEEK = '2023-01-23';
const DEFAULT_START_DATE = '2023-05-22';
const DEFAULT_END_DATE = '2023-06-25';
const LINEAR_START_DATE = '2025-05-19';
const LINEAR_END_DATE = '2025-06-22';

// Override the date for test & prospect companies.
export const overrideDate = (company: string, date: string): string =>
  TEST_COMPANIES.includes(company) ? DEFAULT_WEEK : date;

export const overrideDateLinear = (company: string, date: string): string =>
  TEST_COMPANIES.includes(company) ? LINEAR_START_DATE : date;

// Override the date range for test & prospect companies.
export const overrideDateRange = (
  company: string,
  dateRange: DateRange | undefined
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }
  return TEST_COMPANIES.includes(company)
    ? { start: DEFAULT_START_DATE, end: DEFAULT_END_DATE }
    : dateRange;
};

export const overrideDateRangeLinear = (
  company: string,
  dateRange: DateRange | undefined
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }
  return TEST_COMPANIES.includes(company)
    ? { start: LINEAR_START_DATE, end: LINEAR_END_DATE }
    : dateRange;
};
